import { render, staticRenderFns } from "./AssignInfo.vue?vue&type=template&id=3d99e996&scoped=true&"
import script from "./AssignInfo.vue?vue&type=script&lang=js&"
export * from "./AssignInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d99e996",
  null
  
)

export default component.exports